import React from 'react';
import { Table, Divider } from "antd";
import {getGridTableHeight, amountFormatter} from '../Common/util';

/** -------------------------------------------------------------------------- **/
function ItemRs({itemList, measureList, sumData}) {


// 상세 진단결과
const itemColumnData =  [
    {
        title: '분류',
        colSpan: 2,
        rowSpan: 2,
        align: 'center',
        children : [
            {
                dataIndex: 'type',
                key: 'type',
                width: '120px',
                align: 'center',
                fixed: 'left',
                colSpan:0,
                render: (value, row, index) => {
                    const obj = {
                        children : value,
                        props : {},
                    }

                    if(index >-1 && value == itemList[index - 1]?.type) {
                        obj.props.rowSpan = 0;
                    } else {
                        for (
                            let i = 0;
                            index + i != itemList.length && value == itemList[index + i]?.type;
                            i += 1
                        ) {
                            obj.props.rowSpan = i + 1;
                        }
                    }

                    return obj;
                },
            },
            {
                dataIndex: 'code',
                key: 'code',
                width: '70px',
                align: 'center',
                fixed: 'left',
                colSpan: 0,
            }
            
        ]
    },
    {
        title: '진단 항목',
        dataIndex: 'name',
        align: 'left',
        key: 'name',
        width: '180px',
        fixed: 'left',
        ellipsis : true,

    },
    {
        title: '조치적용시기',
        align: 'center',
        children: [
            {
                title: '단기',
                dataIndex: 'short_term',
                key: 'short_term',
                width: '70px',
                align: 'center',
            },
            {
                title: '중기',
                dataIndex: 'mid_to_long_term',
                key: 'mid_to_long_term',
                width: '70px',
                align: 'center',
            },
            {
                title: '장기',
                dataIndex: 'long_term',
                key: 'long_term',
                width: '70px',
                align: 'center',
            },
        ]
    },
    {
        title: '위험대응전략',
        align: 'center',
        children: [
            {
                title: '감소',
                dataIndex: 'risk_reduction',
                key: 'risk_reduction',
                width: '70px',
                align: 'center',
                className: 'fix_col',
            },
            {
                title: '수용',
                dataIndex: 'risk_acception',
                key: 'risk_acception',
                width: '70px',
                align: 'center',
                className: 'fix_col',
            },
            {
                title: '이전',
                dataIndex: 'risk_transfer',
                key: 'risk_transfer',
                width: '70px',
                align: 'center',
                className: 'fix_col',
            },
            {
                title: '회피',
                dataIndex: 'risk_evasion',
                key: 'risk_evasion',
                width: '70px',
                align: 'center',
                className: 'fix_col',
            },
        ]
    },
    {
        title: '위험개수',
        dataIndex: 'total_risk',
        key: 'total_risk',
        width: '70px',
        align: 'center',

    },
];

const itemColumnData2 =  [
    // {
    //     title: '분류',
    //     colSpan: 2,
    //     rowSpan: 2,
    //     align: 'center',
    //     children : [
    //         {
    //             dataIndex: 'type',
    //             key: 'type',
    //             width: '120px',
    //             align: 'center',
    //             fixed: 'left',
    //             colSpan : 0,
    //             render: (value, row, index) => {
    //                 const obj = {
    //                     children : value,
    //                     props : {},
    //                 }
    //                 console.log(index+"=="+value+"--");
                    
    //                 if(index === 0) {
    //                     obj.props.rowSpan = itemList.length;
    //                     // 첫 행에서 rowSpan으로 행을 합치면 나머지 행은 rowSpan을 0으로 해줘야 한다. 
    //                     // 안해주면 한 필드씩 오른쪽으로 밀리게 된다. 
    //                 }else{
    //                     obj.props.rowSpan = 0;
    //                 }
                    
    //                 return obj;
    //             },
    //         },
    //         {
    //             dataIndex: 'code',
    //             key: 'code',
    //             width: '70px',
    //             align: 'center',
    //             fixed: 'left',
    //             colSpan: 0,
    //         }
            
    //     ]
    // },
    {
        title: '분류',
        align: 'center',
        dataIndex: 'code',
        key: 'code',
        width: '195px',
        align: 'center',
        fixed: 'left',

    },
    {
        title: '진단 항목',
        dataIndex: 'name',
        align: 'center',
        key: 'name',
        width: '180px',
        fixed: 'center',
        ellipsis : true,

    },
    {
        title: '조치적용시기',
        align: 'center',
        children: [
            {
                title: '단기',
                dataIndex: 'short_term',
                key: 'short_term',
                width: '70px',
                align: 'center',
            },
            {
                title: '중기',
                dataIndex: 'mid_to_long_term',
                key: 'mid_to_long_term',
                width: '70px',
                align: 'center',
            },
            {
                title: '장기',
                dataIndex: 'long_term',
                key: 'long_term',
                width: '70px',
                align: 'center',
            },
        ]
    },
    {
        title: '위험대응전략',
        align: 'center',
        children: [
            {
                title: '감소',
                dataIndex: 'risk_reduction',
                key: 'risk_reduction',
                width: '70px',
                align: 'center',
                className: 'fix_col',
            },
            {
                title: '수용',
                dataIndex: 'risk_acception',
                key: 'risk_acception',
                width: '70px',
                align: 'center',
                className: 'fix_col',
            },
            {
                title: '이전',
                dataIndex: 'risk_transfer',
                key: 'risk_transfer',
                width: '70px',
                align: 'center',
                className: 'fix_col',
            },
            {
                title: '회피',
                dataIndex: 'risk_evasion',
                key: 'risk_evasion',
                width: '70px',
                align: 'center',
                className: 'fix_col',
            },
        ]
    },
    {
        title: '위험개수',
        dataIndex: 'total_risk',
        key: 'total_risk',
        width: '70px',
        align: 'center',

    },
];

    return (
        <>
            <div id="divTabs2" className="section" style={{height:getGridTableHeight(180), overflowY:'auto'}}>
                <div className="sub_title">
                        {'■ 위험관리 통계'}
                </div>
                <div style={{padding: '5px 10px'}}>
                    <Table columns={itemColumnData2}
                        dataSource={measureList}
                        pagination={false}
                        rowKey="id"
                        bordered size={"small"}
                        className="sub_table"
                        summary={() => {
                            return (
                              <>
                                <Table.Summary.Row>
                                  <Table.Summary.Cell index={0} colSpan={2} className={'sum_col'}>{'계'}</Table.Summary.Cell>
                                  <Table.Summary.Cell index={1} className={'sum_col'}>{amountFormatter(sumData.short_term)}</Table.Summary.Cell>
                                  <Table.Summary.Cell index={2} className={'sum_col'}>{amountFormatter(sumData.mid_to_long_term)}</Table.Summary.Cell>
                                  <Table.Summary.Cell index={3}>{amountFormatter(sumData.long_term)}</Table.Summary.Cell>
                                  <Table.Summary.Cell index={4}>{amountFormatter(sumData.risk_reduction)}</Table.Summary.Cell>
                                  <Table.Summary.Cell index={5}>{amountFormatter(sumData.risk_acception)}</Table.Summary.Cell>
                                  <Table.Summary.Cell index={5}>{amountFormatter(sumData.risk_transfer)}</Table.Summary.Cell>
                                  <Table.Summary.Cell index={5}>{amountFormatter(sumData.risk_evasion)}</Table.Summary.Cell>
                                  <Table.Summary.Cell index={6}>{amountFormatter(sumData.total_risk)}</Table.Summary.Cell>
                                </Table.Summary.Row>
                              </>
                            );
                        }}
                        >
                    </Table>
                </div>
                <Divider />
                <div style={{padding: '5px 10px'}}>
                    <Table columns={itemColumnData}
                        dataSource={itemList}
                        pagination={false}
                        bordered size={"small"}
                        className="sub_table"
                        summary={() => {
                            return (
                              <>
                                <Table.Summary.Row>
                                  <Table.Summary.Cell index={0} colSpan={3} className={'sum_col'}>{'계'}</Table.Summary.Cell>
                                  <Table.Summary.Cell index={1} className={'sum_col'}>{amountFormatter(sumData.short_term)}</Table.Summary.Cell>
                                  <Table.Summary.Cell index={2} className={'sum_col'}>{amountFormatter(sumData.mid_to_long_term)}</Table.Summary.Cell>
                                  <Table.Summary.Cell index={3} className={'sum_col'}>{amountFormatter(sumData.long_term)}</Table.Summary.Cell>
                                  <Table.Summary.Cell index={4}>{amountFormatter(sumData.risk_reduction)}</Table.Summary.Cell>
                                  <Table.Summary.Cell index={5}>{amountFormatter(sumData.risk_acception)}</Table.Summary.Cell>
                                  <Table.Summary.Cell index={4}>{amountFormatter(sumData.risk_transfer)}</Table.Summary.Cell>
                                  <Table.Summary.Cell index={5}>{amountFormatter(sumData.risk_evasion)}</Table.Summary.Cell>
                                  <Table.Summary.Cell index={6}>{amountFormatter(sumData.total_risk)}</Table.Summary.Cell>
                                </Table.Summary.Row>
                              </>
                            );
                        }}
                        >
                    </Table>
                </div>
            </div>
        </>
    );
}
export default ItemRs;